export default [
  {
    path: '/pickup-card-activators',
    name: 'pickup-card-activator',
    meta: { requiresAuth: true },
    component: () => import('@/pages/pickup-card-activator/index.vue')
  }
]
